import classNames from 'classnames';
import styles from './ArticleInfo.module.scss';
import { Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';
import { LinkButton } from 'ui/components/1-atoms/Action/LinkButton/LinkButton';
import { Button } from 'ui/components/1-atoms/Action/Button/Button';

export interface ArticleInfoProps {
	className?: string;
	infoColumns?: { heading?: string; line?: string; line2?: string }[];
	linkButton?: { name: string; url: string };
	button?: {
		text: string;
		onClick: () => void;
		showButton: boolean;
	};
	layoutType?: 'Article' | 'Event';
}

export const ArticleInfo: React.FC<ArticleInfoProps> = ({ className, infoColumns, linkButton, button, layoutType }) => (
	<div className={classNames(styles.ArticleInfo, className)}>
		<div className={classNames(styles.ArticleInfo_content, { [styles.ArticleInfo_content__event]: layoutType === 'Event' })}>
			{infoColumns?.map((infoColumn, index) => (
				<div key={index} className={classNames(styles.ArticleInfo_element)}>
					{infoColumn.heading && <Paragraph bold className={classNames(styles.ArticleInfo_elementHeading)}>{infoColumn.heading}</Paragraph>}
					{infoColumn.line && <Paragraph className={classNames(styles.ArticleInfo_elementText)}>{infoColumn.line}</Paragraph>}
					{infoColumn.line2 && <Paragraph className={classNames(styles.ArticleInfo_elementText)}>{infoColumn.line2}</Paragraph>}
				</div>
			))}
			{linkButton && (
				<div className={styles.ArticleInfo_linkButton}>
					<LinkButton style="primary" href={linkButton.url}>
						{linkButton.name}
					</LinkButton>
				</div>
			)}
			
			{button && (
				<div className={classNames([styles.ArticleInfo_actionButton, button.showButton && styles.ArticleInfo_actionButton__hidden])}>
					<Button
						style="primary"
						title={button?.text}
						onClick={button?.onClick}
					>
						{button?.text}
					</Button>
				</div>
			)}
		</div>
	</div>
);
